import { EntryCriteriaTypes } from '@celito.clients/enums';
import { IOption } from 'libs/shared/src/lib/in-house-input-select/in-house-input-select.model';
import {
  defineEmptyRule,
  getDefaultRules,
} from 'libs/shared/src/lib/rules-component/utils/utils';
import { useFieldArray, useFormContext } from 'react-hook-form';

import {
  CriteriaConditionType,
  CriteriaConditionTypeProps,
} from './criteria-condition-type.model';
import { CriteriaConditionTypeView } from './criteria-condition-type.view';

export const CriteriaConditionTypeController = (
  props: CriteriaConditionTypeProps
) => {
  const methods = useFormContext();

  const { control, setValue, watch } = methods;

  const { append: appendCriteria, remove: removeEntryCriteria } = useFieldArray(
    {
      control,
      name: `${props.formPath}.criteria`,
    }
  );

  const watchedCriteria = watch(props.formPath);

  const onAddEntryCriteria = () => {
    appendCriteria({
      type: EntryCriteriaTypes['State Of Related Objects'],
      validations: {
        comparision: '',
        conditions: defineEmptyRule(),
        isPerformOnConditions: false,
        object: '',
        stage: [],
        relationshipName: '',
        relationShipType: '',
      },
    });
  };

  const onRemoveEntryCriteria = (index: number) => {
    removeEntryCriteria(index);
  };

  const conditionTypes: IOption[] = [
    { text: 'Always', value: '2' },
    { text: 'When', value: '1' },
    { text: 'Never', value: '0' },
  ];

  const defineEmptyEntryCriteria = () => {
    setValue(props.formPath, null);
  };

  const handleConditionType = (conditionType: CriteriaConditionType) => {
    switch (conditionType) {
      case CriteriaConditionType.Never:
        defineEmptyEntryCriteria();
        break;
      case CriteriaConditionType.When:
        setValue(`${props.formPath}.performOnConditions`, getDefaultRules());
        break;

      default:
        setValue(`${props.formPath}.performOnConditions`, []);
    }

    if (!watchedCriteria?.criteria?.length) onAddEntryCriteria();

    methods.setValue(`${props.formPath}.conditionType`, conditionType);
  };

  const entryCriteriaTypes: IOption[] = Object.entries(EntryCriteriaTypes).map(
    ([text, value]) => {
      return {
        text,
        value,
      };
    }
  );

  return (
    <CriteriaConditionTypeView
      {...{
        ...props,
        entryCriteriaTypes,
        onAddEntryCriteria,
        conditionTypes,
        handleConditionType,
        onRemoveEntryCriteria,
      }}
    />
  );
};
